import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddWhatsappLiveChatSettingsForm from './AddWhatsappLiveChatSettingsForm';

export type WhatsappLiveChatSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const WhatsappLiveChatSettingsDrawer = ({ onClose, visible, moduleId }: WhatsappLiveChatSettingsDrawerProps) => {
    const { t } = useTranslation(['whatsappLiveChatModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('whatsappLiveChatModuleDetails:settingsDrawer.cancelButton')}</Button>
                    <Button form="addWhatsappLiveChatSettings" htmlType="submit" type="primary">
                        {t('whatsappLiveChatModuleDetails:settingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('whatsappLiveChatModuleDetails:settingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddWhatsappLiveChatSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default WhatsappLiveChatSettingsDrawer;

export const useWhatsappLivechatSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <WhatsappLiveChatSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
